export const allAuthUsersUrl = (baseUrl?: string): string | undefined => {
  const trimmedBaseUrl = baseUrl?.trim();
  if (!trimmedBaseUrl) {
    return undefined;
  }
  return `${trimmedBaseUrl.replace(/\/+$/, '')}/users`;
};
